import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-test"]
const _hoisted_2 = ["id", "value", "checked"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 21 21" }, [
  /*#__PURE__*/_createElementVNode("path", { d: "M5,10.75 L8.5,14.25 L19.4,2.3 C18.8333333,1.43333333 18.0333333,1 17,1 L4,1 C2.35,1 1,2.35 1,4 L1,17 C1,18.65 2.35,20 4,20 L17,20 C18.65,20 20,18.65 20,17 L20,7.99769186" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    "data-test": _ctx.name,
    class: "checkbox path"
  }, [
    _createElementVNode("input", {
      type: "checkbox",
      id: _ctx.id,
      value: _ctx.name,
      checked: _ctx.checked,
      onInput: _cache[0] || (_cache[0] = (event) => _ctx.$emit('update:checked', event.target?.checked))
    }, null, 40, _hoisted_2),
    _hoisted_3
  ], 8, _hoisted_1))
}